import ENV from '../../env.json'

export default ENV
